import { onMounted, onUnmounted, ref } from 'vue';
import { desktopUpdaterService } from '@/services/desktopUpdaterService.js';

export function useDesktopUpdater() {
    const state = ref(desktopUpdaterService.snapshot());
    const refresh = () => { state.value = desktopUpdaterService.snapshot(); };
    onMounted(() => {
        window.addEventListener('corecry:desktop-update', refresh);
        refresh();
    });
    onUnmounted(() => window.removeEventListener('corecry:desktop-update', refresh));
    return { state, install: desktopUpdaterService.install };
}
